import React from 'react';

function TechT() {
  return <div></div>;
}

export default TechT;
